import theme from '@totallymoney/ui/theme'
import styled from 'styled-components'

const StyledList = styled.ul`
    list-style: disc;
    font-size: 1.6rem;

    > li {
        margin-left: 16px;
        margin-bottom: ${theme.space10};
    }
`

const ContentList = ({ children }: { children: React.ReactNode }) => {
    return <StyledList>{children}</StyledList>
}

export default ContentList
